import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCardinalPlural } from '~/utils/Intl';
import { Action } from '~/Product/Action';
import { showAllProductsAction } from '~/Product/actions';
import { State, ThunkDispatch } from '~/Store';
import Checkbox from '~/UI/Checkbox/Checkbox';

import styles from './styles.less';

export const ShowAllSwitch: React.FunctionComponent<
	React.PropsWithChildren<{
		alternativeProductsCount: number;
	}>
> = ({ alternativeProductsCount }) => {
	const showAllProducts = useSelector<State, boolean>((state) => state.products.showAllProducts);
	const dispatch: ThunkDispatch<Action> = useDispatch();
	const update = React.useCallback((showAllProducts: boolean) => {
		dispatch(showAllProductsAction(!showAllProducts));
	}, []);

	if (alternativeProductsCount === 0) {
		return null;
	}

	return (
		<div className={styles.container}>
			<Checkbox checked={!showAllProducts} onChange={update}>
				hide {alternativeProductsCount} {selectCardinalPlural(alternativeProductsCount, ['product', 'products'])} from
				alternative sources or products which are no longer present in the current datasets.
			</Checkbox>
		</div>
	);
};

ShowAllSwitch.displayName = 'Product.ShowAllSwitch';
